const CREDENTIAL_TYPES = {
  sshkey: 'sshkey',
  sshpw: 'sshpw',
  snmp_v1: 'snmp_v1',
  snmp_v2c: 'snmp_v2c',
  snmp_v3: 'snmp_v3',
  streaming_telemetry: 'streaming_telemetry',
  bgp_md5: 'bgp_md5',
  api_token: 'api_token',
  basic_auth: 'basic_auth',
  ai_api_token: 'ai_api_token',
  mcp_http_headers: 'mcp_http_headers',
  other: 'other',
  cloud: 'cloud'
};

const SNMPV3_AUTH_PROTOCOLS = {
  none: 'none',
  MD5: 'MD5',
  SHA: 'SHA',
  SHA224: 'SHA224',
  SHA256: 'SHA256',
  SHA384: 'SHA384',
  SHA512: 'SHA512'
};

const SNMPV3_PRIVACY_PROTOCOLS = {
  none: 'none',
  DES: 'DES',
  AES: 'AES',
  AES192: 'AES192',
  AES256: 'AES256',
  AES192C: 'AES192C',
  AES256C: 'AES256C'
};

const SNMPV3_AUTH_PROTOCOL_LABELS = {
  [SNMPV3_AUTH_PROTOCOLS.none]: 'None',
  [SNMPV3_AUTH_PROTOCOLS.SHA]: 'SHA (SHA1)'
};

const SNMPV3_PRIVACY_PROTOCOL_LABELS = {
  [SNMPV3_PRIVACY_PROTOCOLS.none]: 'None',
  [SNMPV3_PRIVACY_PROTOCOLS.AES]: 'AES (AES128)'
};

const CREDENTIAL_TYPE_LABELS = {
  [CREDENTIAL_TYPES.basic_auth]: 'Basic Authentication',
  [CREDENTIAL_TYPES.sshkey]: 'SSH Private Key',
  [CREDENTIAL_TYPES.sshpw]: 'SSH Password',
  [CREDENTIAL_TYPES.snmp_v1]: 'SNMP v1 Community String',
  [CREDENTIAL_TYPES.snmp_v2c]: 'SNMP v2 Community String',
  [CREDENTIAL_TYPES.snmp_v3]: 'SNMP v3 Authentication',
  [CREDENTIAL_TYPES.streaming_telemetry]: 'Streaming Telemetry Authentication',
  [CREDENTIAL_TYPES.bgp_md5]: 'BGP MD5',
  [CREDENTIAL_TYPES.api_token]: 'API Token',
  [CREDENTIAL_TYPES.ai_api_token]: 'AI API Token',
  [CREDENTIAL_TYPES.mcp_http_headers]: 'MCP HTTP Headers',
  [CREDENTIAL_TYPES.other]: 'Other',
  [CREDENTIAL_TYPES.cloud]: 'Cloud'
};

// special case: these credential types have the same key-value sets so you can switch between them freely.
// Note that upgrade-only relationships are not supported currently and should not be attempted!
const COMPATIBLE_CREDENTIAL_TYPES = {
  [CREDENTIAL_TYPES.snmp_v1]: [CREDENTIAL_TYPES.snmp_v2c],
  [CREDENTIAL_TYPES.snmp_v2c]: [CREDENTIAL_TYPES.snmp_v1]
};

const CREDENTIAL_TYPE_TEMPLATES = {
  [CREDENTIAL_TYPES.snmp_v1]: [
    {
      key: 'community'
    }
  ],
  [CREDENTIAL_TYPES.snmp_v2c]: [
    {
      key: 'community'
    }
  ],
  [CREDENTIAL_TYPES.snmp_v3]: [
    {
      key: 'username',
      label: 'Username'
    },
    {
      key: 'authentication_protocol',
      defaultValue: SNMPV3_AUTH_PROTOCOLS.none,
      options: Object.values(SNMPV3_AUTH_PROTOCOLS).map((authProtocol) => ({
        value: authProtocol,
        label: SNMPV3_AUTH_PROTOCOL_LABELS[authProtocol] || authProtocol
      }))
    },
    {
      key: 'authentication',
      label: 'Authentication passphrase',
      optionalWhen: { siblingKey: 'authentication_protocol', value: 'none' }
    },
    {
      key: 'privacy_protocol',
      defaultValue: SNMPV3_PRIVACY_PROTOCOLS.none,
      options: Object.values(SNMPV3_PRIVACY_PROTOCOLS).map((privProtocol) => ({
        value: privProtocol,
        label: SNMPV3_PRIVACY_PROTOCOL_LABELS[privProtocol] || privProtocol
      }))
    },
    {
      key: 'privacy',
      label: 'Privacy passphrase',
      optionalWhen: { siblingKey: 'privacy_protocol', value: 'none' }
    },
    {
      key: 'context_name',
      placeholder: 'Use only for VRF or Routing Instance Configurations',
      optional: true,
      permissionFlag: 'contextName.enabled'
    }
  ],
  [CREDENTIAL_TYPES.streaming_telemetry]: [
    {
      key: 'username',
      label: 'Username'
    },
    {
      key: 'password',
      label: 'Password'
    }
  ],
  [CREDENTIAL_TYPES.bgp_md5]: [
    {
      key: 'peer_asn'
    },
    {
      key: 'md5_password'
    }
  ],
  [CREDENTIAL_TYPES.ai_api_token]: [
    {
      key: 'api_key'
    }
  ],
  [CREDENTIAL_TYPES.sshkey]: [
    {
      key: 'username'
    },
    {
      key: 'private_key'
    },
    {
      key: 'passphrase',
      optional: true
    }
  ],
  [CREDENTIAL_TYPES.sshpw]: [
    {
      key: 'username'
    },
    {
      key: 'password',
      optional: true
    }
  ]
};

module.exports = {
  CREDENTIAL_TYPES,
  CREDENTIAL_TYPE_LABELS,
  CREDENTIAL_TYPE_TEMPLATES,
  COMPATIBLE_CREDENTIAL_TYPES,
  SNMPV3_AUTH_PROTOCOLS,
  SNMPV3_PRIVACY_PROTOCOLS,
  SNMPV3_AUTH_PROTOCOL_LABELS,
  SNMPV3_PRIVACY_PROTOCOL_LABELS
};
